<header class="esf-main-header esf-main-header--dark">
  <div class="esf-main-header__unit">
    <app-breadcrumbs></app-breadcrumbs>
  </div>
  <div class="esf-main-header__unit" *ngIf="selectedClub != null">
    <img class="esf-main-header__logo" *ngIf="selectedClub?.pathToLogo" (click)="changeRoute()" src="{{ selectedClub.pathToLogo }}">
    <span class="esf-main-header__logo temporary-logo-text" (click)="changeRoute()" *ngIf="!selectedClub?.pathToLogo ">{{ selectedClub.name }}</span>
  </div>
  <div class="esf-main-header__unit" *ngIf="selectedClub == null">
    <span class="esf-main-header__logo temporary-logo-text"></span>
  </div>
  <div class="esf-main-header__unit" (click)="toggleMenu()">
    <div class="esf-main-header__unit">
      <div class="esf-dropdown">
        <div class="esf-main-header__account esf-js-dropdown-trigger" *ngIf="authenticatedUser">
          <div class="esf-main-header__account-user">{{ authenticatedUser.firstName.charAt(0) }}{{ authenticatedUser.lastName.charAt(0) }}</div>
          <span class="esf-main-header__account-name">{{ authenticatedUser.firstName }} {{ authenticatedUser.lastName }}</span>
          <svg class="esf-icon esf-main-header__account-icon" width="12" height="12">
            <use xlink:href="#esf-icon-small-down"></use>
          </svg>
        </div>
        <ul class="esf-dropdown__items esf-dropdown__items--right" [ngClass]="{'-is-open': isMenuOpened}">
          <li i18n='@@headerComponent.dropdownMenu.link.viewProfile' class="esf-dropdown__item" (click)="goToProfilePage()">View profile</li>
          <li i18n='@@headerComponent.dropdownMenu.link.logout' class="esf-dropdown__item" (click)="logout()">Logout</li>
        </ul>
      </div>
    </div>
  </div>
</header>
